import { render } from "./CoachItem.vue?vue&type=template&id=b7215cd6&scoped=true"
import script from "./CoachItem.vue?vue&type=script&lang=js"
export * from "./CoachItem.vue?vue&type=script&lang=js"

import "./CoachItem.vue?vue&type=style&index=0&id=b7215cd6&scoped=true&lang=css"

import exportComponent from "D:\\Dwiki\\learn-vue\\vue-cli\\practice\\coach-vue\\coach-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7215cd6"]])

export default __exports__